class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, this.dataset.name, this.dataset.key, this.dataset.freeItem);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    this.cartItemIdentifier = 'CartItem';
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.key);
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        // console.log(responseText)
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        if (sourceQty) this.innerHTML = sourceQty.innerHTML;
        if(typeof reChargeCartJS == 'function') {
            console.log('CU - add 2')
            let hasSubscriptions = false
            const newItems = document.querySelectorAll('.cart-item');
            newItems.forEach((item)=>{
                if(item.dataset.isSubscription) {
                    if(JSON.parse(item.dataset.isSubscription)) {
                        hasSubscriptions = true
                    }
                }
            })
            window.ReCharge.cart_options.disable = !hasSubscriptions;
            reChargeCartJS()
        } 
      })
      .catch(e => {
        if(typeof restoreCheckoutButton == 'function') {
            restoreCheckoutButton()
        }
        if(typeof reChargeCartJS == 'function') {
            console.log('CU - add after fail')
            let hasSubscriptions = false
            const newItems = document.querySelectorAll('.cart-item');
            newItems.forEach((item)=>{
                if(item.dataset.isSubscription) {
                    if(JSON.parse(item.dataset.isSubscription)) {
                        hasSubscriptions = true
                    }
                }
            })
            window.ReCharge.cart_options.disable = !hasSubscriptions;
            reChargeCartJS()
        }
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents'
      }
    ];
  }

  async updateQuantity(line, quantity, name, id, freeItem) {
    // Format item key for querySelectors
    const itemID = id.split(":");
    itemID.splice(1, 0, "\\:");
    const newID = itemID.join("");
    
    if (this.querySelector(`#${ this.cartItemIdentifier }-${ newID }`).dataset.limitedQuantityPerOrder != false) {
      var limitedQuantityPerOrder = parseInt(this.querySelector(`#${ this.cartItemIdentifier }-${ newID }`).dataset.limitedQuantityPerOrder);
      if (limitedQuantityPerOrder && quantity > limitedQuantityPerOrder) {
        this.querySelector(`#${ this.cartItemIdentifier }-${ newID } .quantity__input`).stepDown();
        var dialog = document.getElementById('limited_quantity_per_order__dialog');
        dialog.querySelector('.limited_quantity_per_order__copy').innerHTML = dialog.querySelector('.limited_quantity_per_order__copy').innerHTML.replace('[max_quantity]', limitedQuantityPerOrder);
        dialog.showModal();
        return;
      }
    }

    const cart = await fetch('/cart.js').then(res => res.json());
    const cartToken = cart.token;

    if (freeItem) {      
      sessionStorage.setItem(`gwp_removed-${cartToken}`, "true");
    }

    this.enableLoading(newID);

    const body = JSON.stringify({
      id,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        //Filter out SavedBy from item counts
        const savedby = parsedState.items.find((item) => item.vendor === "SavedBy");
        let itemCount = parsedState.item_count;
        let itemsLength = parsedState.items.length;
        if (savedby) {
          itemCount -= 1;
          itemsLength -= 1;
        }
        
        const quantityElement = document.getElementById(`Quantity-${id}`) || document.getElementById(`Drawer-quantity-${id}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(id, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', itemCount === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', itemCount === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', itemCount === 0);

        /* When GWP is enabled */
        this.renderContents(parsedState);

        // checkGWP(null, (newResponse) => {
        //   var response = parsedState
        //   if (newResponse) response = newResponse
        //   this.renderContents(response);
        //   this.onCartUpdate();
        // });

        const updatedItem = parsedState.items.find((item) => item.key === id);
        const updatedValue = updatedItem ? updatedItem.quantity : undefined;
        
        let message = '';
        if (items.length === itemsLength && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(id, message);
        if(typeof initCartSwiper == 'function') {
            initCartSwiper()
        }
        if(typeof initCartGwpTriggerProducts == 'function') {
            initCartGwpTriggerProducts()
        }

        const lineItem = document.getElementById(`CartItem-${id}`) || document.getElementById(`CartDrawer-Item-${id}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (itemCount === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});
        if(typeof reChargeCartJS == 'function') {
            let hasSubscriptions = false
            const newItems = document.querySelectorAll('cart-drawer-items .cart-item');
            newItems.forEach((item)=>{
                if(item.dataset.isSubscription) {
                    if(JSON.parse(item.dataset.isSubscription)) {
                        hasSubscriptions = true
                    }
                }
            })
            window.ReCharge.cart_options.disable = !hasSubscriptions;
            reChargeCartJS()
        }
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(newID);
      });
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    }));
  }

  updateLiveRegions(id, message) {
    const lineItemError = document.getElementById(`Line-item-error-${id}`) || document.getElementById(`CartDrawer-LineItemError-${id}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(id) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${id} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${id} .loading-overlay`);
    
    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));
    
    this.querySelector(`#CartDrawer-Item-${id}`).setAttribute('disabled', 'disabled');
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(id) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${id} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${id} .loading-overlay`);

    this.querySelector(`#CartDrawer-Item-${id}`).removeAttribute('disabled');
    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  getItemQuantities() {
    var itemQuantities = {};
    this.querySelectorAll('.cart-item:not(.hidden)').forEach(cartItem => {
      var cartItemVariantId = cartItem.querySelector('input.quantity__input')?.dataset.quantityVariantId || null;
      var cartItemVariantQuantity = parseInt(cartItem.querySelector('input.quantity__input')?.dataset.cartQuantity) || null;
      if (cartItemVariantId && cartItemVariantQuantity) itemQuantities[cartItemVariantId] = cartItemVariantQuantity;
    });
    return itemQuantities;
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
      constructor() {
        super();

      this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER))
      }
  });
};

class TravelSizeUpsell extends HTMLElement {
  constructor() {
    super();
    this.fullSizeId = this.dataset.largeId;
    this.fullSizeQuantity = this.dataset.quantity;
    this.fullSizeTitle = this.dataset.largeTitle;
    this.fullsizeSku = this.dataset.largeSku;
    this.travelSizeId = this.dataset.travelId;
    this.travelSizeTitle = this.dataset.travelTitle;
    this.travelSizeSku = this.dataset.travelSku;
    this.duoId = this.dataset.duoId;
    this.itemKey = this.dataset.key;

    this.atc = this.querySelector('button[type="button"]');
    this.atc.addEventListener('click', this.processUpsell.bind(this));

    this.closeButton = this.querySelector('.close_button');
    this.closeButton.addEventListener('click', () => { this.closest('.travel_upsell_container').remove(); });
    this.loadingOverlay = this.closest('.cart-item')?.querySelector('.loading-overlay');
    this.cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
  }
    
  processUpsell() {
    this.loadingOverlay?.classList.remove('hidden');
    this.removeFullSize();
    // this.loadingOverlay?.classList.add('hidden');
    }

  buildDuo() {
    const body = JSON.stringify({
      id: this.duoId,
      quantity: 1,
      properties: {
        __samples: {
          [this.fullSizeId]: "1",
          [this.travelSizeId]: "1",
        },
        __skus: `1x${this.fullsizeSku};1x${this.travelSizeSku};`,
        1: `1x ${this.fullSizeTitle}`,
        2: `1x ${this.travelSizeTitle}`
      },
      sections: this.cartItems.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    
    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
    
        if (parsedState.errors) {
          console.log(parsedState.errors);
          return;
        }
        this.cartItems.renderContents(parsedState);
        if(typeof initCartSwiper == 'function') {
          initCartSwiper()
        }
        if(typeof initCartGwpTriggerProducts == 'function') {
            initCartGwpTriggerProducts()
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-upsell'});
        
      });
  }
  
  removeFullSize() {
    const body = JSON.stringify({
      id: this.fullSizeId,
      quantity: this.fullSizeQuantity - 1,
    });
  
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
  
        if (parsedState.errors) {
          console.log(parsedState.errors);
          return;
        }  
        this.buildDuo();
      })
  }
}
customElements.define('travel-size-upsell', TravelSizeUpsell);

